import { handleCustomUDL } from "@utils/UDLUtils";
import { AccordionContainer } from "./accordion-container";

const ANIMATION_TIME = 500;

export class Accordion {
  private el: HTMLElement;
  private details: HTMLDetailsElement;
  private summary: HTMLElement;
  private content: HTMLElement;
  private title: HTMLElement;
  public isAnimating: boolean;
  private container: AccordionContainer;
  private dataset: DOMStringMap;


  constructor(el: HTMLElement, container: AccordionContainer) {
    this.el = el;
    this.details = el.querySelector("details");
    this.summary = el.querySelector("summary");
    this.content = el.querySelector(".accordioncontent");
    this.title = el.querySelector(".comp-accordion-header-content");
    this.isAnimating = false;

    this.container = container;
    this.dataset = el.dataset;

    this.open = this.open.bind(this);
    this.isOpen = this.isOpen.bind(this);
    this.handleDataTracking = this.handleDataTracking.bind(this);
  }

  private handleDataTracking() {
    if (this.dataset.eventTracking === "true") {
      this.summary.addEventListener("click", (e) => {
        if (this.isOpen()) {
          return;
        }

        const params = { ...this.dataset };

        delete params["component"];
        delete params["eventTracking"];

        params.link_text = this.title?.innerText || "";

        handleCustomUDL("accordion_panel_expand", params);
      });
    }
  }

  public isOpen() {
    return this.details.hasAttribute("open");
  }

  public init() {
    this.handleDataTracking();
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = this.isOpen();

      isOpen ? this.close() : this.open();
    });

    return this;
  }

  private toggleHeaderClosingAnimationClass(isActive) {
    const animationClass = "comp-accordion-header--closing-animation";

    if (isActive) {
      this.summary.classList.add(animationClass);
    } else {
      this.summary.classList.remove(animationClass);
    }
  }

  private open() {
    if (this.container.isAnyAccordionAnimating()) {
      return;
    }

    const scrollHeight = this.content.scrollHeight;
    let start = 0;

    const step = (timestamp) => {
      if (start === 0) {
        start = timestamp;
      }
      const elapsed = timestamp - start;
      const timePassed = Math.min(elapsed, ANIMATION_TIME);
      const shift = scrollHeight * (timePassed / ANIMATION_TIME);

      this.content.style.height = `${shift}px`;
      this.isAnimating = true;
      if (timePassed < ANIMATION_TIME) {
        requestAnimationFrame(step);
      } else {
        this.content.style.height = "";
        this.isAnimating = false;
      }
    };
    this.content.style.height = "0px";
    this.details.setAttribute("open", "");
    this.container.closeAllButCurrent(this);
    requestAnimationFrame(step);
  }

  public close() {
    if (this.container.isAnyAccordionAnimating()) {
      return;
    }

    const scrollHeight = this.content.scrollHeight;
    let start = 0;

    const step = (timestamp) => {
      if (start === 0) {
        start = timestamp;
      }
      const elapsed = timestamp - start;
      const timePassed = Math.min(elapsed, ANIMATION_TIME);
      const shift = scrollHeight - scrollHeight * (timePassed / ANIMATION_TIME);

      this.content.style.height = `${shift}px`;
      this.isAnimating = true;
      if (timePassed < ANIMATION_TIME) {
        requestAnimationFrame(step);
      } else {
        this.details.removeAttribute("open");
        this.content.style.height = "";
        this.toggleHeaderClosingAnimationClass(false);
        this.isAnimating = false;
      }
    };
    this.toggleHeaderClosingAnimationClass(true);
    requestAnimationFrame(step);
  }
}
